(function ($) {
  $(window).on('elementor/frontend/init', function () {
    var easing = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function cancelWidthAnimations(swiper) {
      (swiper.featuredWidthAnimations || []).forEach(function (animation) {
        animation.cancel();
      });
      swiper.featuredWidthAnimations = [];
    }

    function sizeSlides(swiper) {
      var slides = Array.from(swiper.slides);
      var widths = slides.map(function (slide) {
        return slide.getBoundingClientRect().width;
      });
      cancelWidthAnimations(swiper);

      slides.forEach(function (slide, index) {
        slide.classList.toggle('featured-slider__slide--active', index === swiper.activeIndex);
      });
      // Measure the final layout before animating, so Swiper targets the correct position.
      swiper.updateSlides();

      var duration = swiper.initialized ? (swiper.featuredTransitionDuration || 0) : 0;
      if (!duration || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      slides.forEach(function (slide, index) {
        var width = slide.getBoundingClientRect().width;
        if (Math.abs(width - widths[index]) < 1) {
          return;
        }
        swiper.featuredWidthAnimations.push(slide.animate([
          { width: widths[index] + 'px' },
          { width: width + 'px' }
        ], { duration: duration, easing: easing }));
      });
    }

    class FeaturedSlider extends elementorModules.frontend.handlers.Base {
      async onInit() {
        super.onInit();
        var root = this.$element.find('.featured-slider')[0];
        var container = root && root.querySelector('.featured-slider__viewport');
        var count = container && container.querySelectorAll('.swiper-slide').length;
        if (!container || count < 2) {
          return;
        }

        var swiper = await new elementorFrontend.utils.swiper(container, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          loop: true,
          loopedSlides: count,
          speed: 700,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          pagination: {
            el: root.querySelector('.featured-slider__pagination'),
            clickable: true,
            bulletElement: 'button'
          },
          navigation: false,
          on: {
            setTransition: function (instance, duration) {
              instance.featuredTransitionDuration = duration;
              instance.wrapperEl.style.transitionTimingFunction = easing;
            },
            beforeResize: cancelWidthAnimations,
            beforeDestroy: cancelWidthAnimations,
            init: sizeSlides,
            activeIndexChange: sizeSlides,
            beforeTransitionStart: function (instance) {
              // Re-align against the grid after the active image changes width.
              var offset = instance.slidesGrid[instance.activeIndex] || 0;
              instance.setTranslate(-offset);
            }
          }
        });

        if (this.disposed) {
          swiper.destroy(true, true);
          return;
        }
        this.swiper = swiper;
      }

      onDestroy() {
        this.disposed = true;
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
        super.onDestroy();
      }
    }

    elementorFrontend.hooks.addAction('frontend/element_ready/custom-featured-slider.default', function ($element) {
      elementorFrontend.elementsHandler.addHandler(FeaturedSlider, { $element: $element });
    });
  });
})(jQuery);
